import { render, staticRenderFns } from "./BaseCardInfo.vue?vue&type=template&id=64e42f2c&scoped=true&"
import script from "./BaseCardInfo.vue?vue&type=script&lang=js&"
export * from "./BaseCardInfo.vue?vue&type=script&lang=js&"
import style0 from "./BaseCardInfo.vue?vue&type=style&index=0&id=64e42f2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e42f2c",
  null
  
)

export default component.exports